// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGSplitSeries2IconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  display: "block",
};

export default class SVGSplitSeries2Icon extends PureComponent<
  ISVGSplitSeries2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
        preserveAspectRatio="xMidYMid meet"
      >
        <g id="Layer_2" display="none">
          <rect
            x="0.08"
            y="0.082"
            display="inline"
            fill="#393939"
            width="34.84"
            height="34.918"
          />
        </g>
        <g id="Layer_1" display="none">
          <g display="inline">
            <path
              fill="#FFFFFF"
              d="M15.053,0.775c-0.996-0.742-2.505-0.693-4.292-0.693c-2.63,0-5.261,0-7.892,0
			C2.646,0.225,2.298,0.182,2.04,0.29C1.531,0.502,0.944,0.957,0.655,1.398C0.097,2.25,0.17,3.642,0.17,5.066
			c0,2.789-0.459,8.348,0.693,9.899c1.167,1.572,6.024,1.038,8.791,1.038c2.058,0,4.231,0.175,5.399-0.692
			c0.968-0.718,1.039-2.093,1.039-3.807c0-2.215,0-4.431,0-6.646C16.092,3.038,16.081,1.539,15.053,0.775z M14.43,13.65
			c-0.319,0.935-1.371,0.831-2.63,0.831c-2.169,0-4.338,0-6.507,0c-0.742,0-2.301,0.22-2.769-0.139
			c-1.058-0.362-0.831-1.851-0.831-3.253c0-2.815,0-5.63,0-8.446C1.822,2.178,2.23,1.976,2.524,1.674
			c0.142-0.028,0.133-0.017,0.208-0.069c2.676,0,5.354,0,8.03,0c0.707,0,2.582-0.158,2.977,0.139
			c0.936,0.32,0.831,1.371,0.831,2.631c0,2.168,0,4.338,0,6.507C14.569,11.624,14.789,13.182,14.43,13.65z"
            />
            <path
              fill="#FFFFFF"
              d="M33.882,0.775c-0.995-0.742-2.504-0.693-4.292-0.693c-2.63,0-5.262,0-7.891,0
			c-0.225,0.143-0.573,0.1-0.831,0.208c-0.509,0.213-1.097,0.667-1.384,1.108c-0.561,0.852-0.485,2.244-0.485,3.668
			c0,2.789-0.459,8.348,0.692,9.899c1.166,1.569,6.025,1.038,8.791,1.038c2.062,0,4.229,0.176,5.398-0.692
			c0.973-0.721,1.039-2.087,1.039-3.807c0-2.215,0-4.431,0-6.646C34.92,3.044,34.907,1.537,33.882,0.775z M33.26,13.65
			c-0.32,0.935-1.371,0.831-2.631,0.831c-2.169,0-4.339,0-6.507,0c-0.742,0-2.302,0.22-2.769-0.139
			c-1.059-0.362-0.832-1.851-0.832-3.253c0-2.815,0-5.63,0-8.446c0.129-0.465,0.537-0.667,0.832-0.969
			c0.143-0.028,0.133-0.017,0.207-0.069c2.676,0,5.354,0,8.029,0c0.708,0,2.582-0.158,2.979,0.139c0.936,0.32,0.83,1.371,0.83,2.631
			c0,2.168,0,4.338,0,6.507C33.398,11.624,33.618,13.182,33.26,13.65z"
            />
            <path
              fill="#FFFFFF"
              d="M15.053,19.604c-0.996-0.74-2.505-0.69-4.292-0.69c-2.63,0-5.261,0-7.892,0
			c-0.224,0.144-0.572,0.101-0.831,0.208c-0.509,0.213-1.096,0.667-1.385,1.107c-0.558,0.854-0.485,2.244-0.485,3.668
			c0,2.789-0.459,8.349,0.693,9.898c1.165,1.568,6.026,1.039,8.791,1.039c2.061,0,4.23,0.176,5.399-0.691
			c0.971-0.721,1.039-2.086,1.039-3.809c0-2.214,0-4.43,0-6.645C16.092,21.873,16.079,20.366,15.053,19.604z M14.43,32.479
			c-0.319,0.938-1.371,0.832-2.63,0.832c-2.169,0-4.338,0-6.507,0c-0.742,0-2.301,0.219-2.769-0.139
			c-1.058-0.361-0.831-1.852-0.831-3.254c0-2.814,0-5.63,0-8.445c0.129-0.466,0.537-0.668,0.831-0.969
			c0.142-0.027,0.133-0.018,0.208-0.068c2.676,0,5.354,0,8.03,0c0.707,0,2.582-0.158,2.977,0.137
			c0.936,0.32,0.831,1.371,0.831,2.633c0,2.168,0,4.338,0,6.507C14.569,30.452,14.789,32.012,14.43,32.479z"
            />
            <path
              fill="#FFFFFF"
              d="M33.882,19.604c-0.995-0.74-2.504-0.69-4.292-0.69c-2.63,0-5.262,0-7.891,0
			c-0.225,0.144-0.573,0.101-0.831,0.208c-0.509,0.213-1.097,0.667-1.384,1.107c-0.561,0.854-0.485,2.244-0.485,3.668
			c0,2.789-0.459,8.349,0.692,9.898c1.166,1.568,6.025,1.039,8.791,1.039c2.059,0,4.23,0.176,5.398-0.691
			c0.969-0.719,1.039-2.094,1.039-3.809c0-2.214,0-4.43,0-6.645C34.92,21.873,34.907,20.366,33.882,19.604z M33.26,32.479
			c-0.32,0.938-1.371,0.832-2.631,0.832c-2.169,0-4.339,0-6.507,0c-0.742,0-2.302,0.219-2.769-0.139
			c-1.059-0.361-0.832-1.852-0.832-3.254c0-2.814,0-5.63,0-8.445c0.129-0.466,0.537-0.668,0.832-0.969
			c0.143-0.027,0.133-0.018,0.207-0.068c2.676,0,5.354,0,8.029,0c0.708,0,2.582-0.158,2.979,0.137c0.936,0.32,0.83,1.371,0.83,2.633
			c0,2.168,0,4.338,0,6.507C33.398,30.452,33.618,32.012,33.26,32.479z"
            />
          </g>
        </g>
        <g id="Layer_3">
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M8.236,10.123c0,0.556-0.35,1.007-0.781,1.007
		H1.857c-0.432,0-0.781-0.451-0.781-1.007V2.906c0-0.556,0.35-1.007,0.781-1.007h5.598c0.431,0,0.781,0.451,0.781,1.007V10.123z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M16.813,10.123c0,0.556-0.35,1.007-0.781,1.007
		h-5.598c-0.432,0-0.781-0.451-0.781-1.007V2.906c0-0.556,0.35-1.007,0.781-1.007h5.598c0.431,0,0.781,0.451,0.781,1.007V10.123z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M25.389,10.123c0,0.556-0.35,1.007-0.781,1.007
		H19.01c-0.432,0-0.781-0.451-0.781-1.007V2.906c0-0.556,0.35-1.007,0.781-1.007h5.598c0.432,0,0.781,0.451,0.781,1.007V10.123z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M33.965,10.123c0,0.556-0.35,1.007-0.781,1.007
		h-5.598c-0.432,0-0.781-0.451-0.781-1.007V2.906c0-0.556,0.35-1.007,0.781-1.007h5.598c0.432,0,0.781,0.451,0.781,1.007V10.123z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M8.236,21.084c0,0.555-0.35,1.006-0.781,1.006
		H1.857c-0.432,0-0.781-0.451-0.781-1.006v-7.219c0-0.557,0.35-1.007,0.781-1.007h5.598c0.431,0,0.781,0.45,0.781,1.007V21.084z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M16.813,21.084c0,0.555-0.35,1.006-0.781,1.006
		h-5.598c-0.432,0-0.781-0.451-0.781-1.006v-7.219c0-0.557,0.35-1.007,0.781-1.007h5.598c0.431,0,0.781,0.45,0.781,1.007V21.084z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M25.389,21.084c0,0.555-0.35,1.006-0.781,1.006
		H19.01c-0.432,0-0.781-0.451-0.781-1.006v-7.219c0-0.557,0.35-1.007,0.781-1.007h5.598c0.432,0,0.781,0.45,0.781,1.007V21.084z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M33.965,21.084c0,0.555-0.35,1.006-0.781,1.006
		h-5.598c-0.432,0-0.781-0.451-0.781-1.006v-7.219c0-0.557,0.35-1.007,0.781-1.007h5.598c0.432,0,0.781,0.45,0.781,1.007V21.084z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M8.195,32.094c0,0.557-0.35,1.008-0.781,1.008
		H1.815c-0.432,0-0.781-0.451-0.781-1.008v-7.217c0-0.559,0.35-1.008,0.781-1.008h5.598c0.431,0,0.781,0.449,0.781,1.008V32.094z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M16.771,32.094c0,0.557-0.35,1.008-0.781,1.008
		h-5.598c-0.432,0-0.781-0.451-0.781-1.008v-7.217c0-0.559,0.35-1.008,0.781-1.008h5.598c0.431,0,0.781,0.449,0.781,1.008V32.094z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M25.348,32.094c0,0.557-0.35,1.008-0.781,1.008
		h-5.598c-0.432,0-0.781-0.451-0.781-1.008v-7.217c0-0.559,0.35-1.008,0.781-1.008h5.598c0.432,0,0.781,0.449,0.781,1.008V32.094z"
          />
          <path
            fill="none"
            stroke="#FFFFFF"
            strokeWidth="0.8"
            strokeMiterlimit="10"
            d="M33.924,32.094c0,0.557-0.35,1.008-0.781,1.008
		h-5.598c-0.432,0-0.781-0.451-0.781-1.008v-7.217c0-0.559,0.35-1.008,0.781-1.008h5.598c0.432,0,0.781,0.449,0.781,1.008V32.094z"
          />
        </g>
      </svg>
    );
  }
}
